import React from "react";
import { FaHome } from "react-icons/fa";
import "../styles/errorScreen.css"; // Assuming you want to style globally

const errorConfig = {
  server: {
    image: "/images/server.png",
    heading: "Server Error",
    description: "Oops! Something went wrong on our end. Please try again later.",
  },
  data_validation: {
    image: "/images/data_validation.png",
    heading: "Invalid Data",
    description: "The data provided seems incorrect or incomplete. Kindly verify and try again.",
  },
  access_denied: {
    image: "/images/access_denied.png",
    heading: "Access Denied",
    description: "You do not have permission to access this page. Please contact support if this is an error.",
  },
};

export default function ErrorScreen({ type = "server" }) {
  const error = errorConfig[type] || errorConfig["server"];

  return (
    <div className="error-screen-wrapper">
      <img src={error.image} alt={error.heading} className="error-image" />
      <h2 className="error-heading">{error.heading}</h2>
      <p className="error-description">{error.description}</p>

      <button className="error-button" onClick={() => {
        if (window.RoyalSkyWebViewAlerts && window.RoyalSkyWebViewAlerts.postMessage) {
          window.RoyalSkyWebViewAlerts.postMessage("GO_HOME");
        } else {
          console.log("GO_HOME");
        }
      }}>
        <FaHome style={{ marginRight: "8px" }} />
        Go Home
      </button>

      {/* 🔁 Refresh Button */}
      <button className="error-refresh-button" onClick={() => window.location.reload()}>
        🔄 Refresh Page
      </button>
    </div>
  );
}